import Dimens from '../../theme/dimens';
import ThemeUtil from '../../theme/theme-util';
import { useTheme } from '@mui/material';

/**
 * useStyles custom hook generates MUI theme-dependent styles for the CustomSwitch component.
 *
 * @returns An object containing the styled classes.
 */
const useStyles = () => {
	const theme = useTheme();
	const { xxs, sm, base,lg } = Dimens.spacing;

	const styles = {
		wrapper: {
			flexDirection: 'column',
			display: 'flex',
			flex: 1,
			pb: Dimens.spacing.base,
		},
		row: {
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'space-between',
			borderRadius: Dimens.radius.md,
			p: `${sm} ${base}`,
			backgroundColor: theme.palette.background.default
		},
		fieldError: {
			...theme.typography.footer,
			m: 0,
			pt: Dimens.spacing.xs,
			color: theme.palette.error.main,
		},
		iosSwitch: {
			width: Dimens.switch.width,
			height: Dimens.switch.height,
			padding: 0,
			'& .MuiSwitch-switchBase': {
				padding: 0,
				transitionDuration: '300ms',
				'&.Mui-checked': {
					transform: 'translateX(16px)',
					'& + .MuiSwitch-track': {
						backgroundColor: theme.palette.primary.main,
						opacity: 1,
						border: 0
					},
					'&.Mui-disabled + .MuiSwitch-track': {
						backgroundColor: theme.palette.primary.light,
						opacity: 0.9
					},
				},
				'&.Mui-disabled .MuiSwitch-thumb': {
					color: theme.palette.background.paper
				},
				'&.Mui-disabled + .MuiSwitch-track': {
					opacity: ThemeUtil.isLightTheme(theme) ? 0.7 : 0.3,
				},
			},
			'& .MuiSwitch-thumb': {
				color: theme.palette.background.paper,
				boxSizing: 'border-box',
				width: Dimens.switch.thumbSize,
				height: Dimens.switch.thumbSize,
				m: xxs,
				boxShadow: 'none'
			},
			'& .MuiSwitch-track': {
				borderRadius: Dimens.radius.xl,
				backgroundColor: theme.palette.text.secondary,
				opacity: 1,
				transition: theme.transitions.create(['background-color'], {
					duration: 500
				}),
			}
		}
	};

	return styles;
};

export default useStyles;